import axios, { AxiosRequestConfig } from 'axios';
import config from '../config.js';

const API_BASE_URL = config.API_BASE_URL;
const net = axios.create({ baseURL: API_BASE_URL });

function request(config: AxiosRequestConfig) {
  return net(config).catch(err => {
    console.error(err);
    return err;
  });
}

type FilterOptionsParams = {
  slug?: string;
  query?: string;
  inStockOnly?: boolean;
  sizes?: [];
  excludeWaitlist?: boolean;
};

const createRestClient = () => {
  return {
    getStreamInfo() {
      return request({
        method: 'GET',
        url: `/live/stream-info`,
      });
    },

    getLiveReplays({
      startingAfter,
      influencerSlug,
    }: {
      startingAfter?: number;
      influencerSlug?: string;
    } = {}) {
      let url = influencerSlug
        ? `/api/influencers/${influencerSlug}/lives`
        : '/live/replays';
      if (startingAfter) {
        url = `${url}?starting_after=${startingAfter}`;
      }
      return request({
        url,
        method: 'GET',
      });
    },

    getLiveEvents(id: number, shownAfter?: number) {
      let url = `/live/${id}/events`;
      if (shownAfter) {
        url = `${url}?shown_after=${shownAfter}`;
      }
      return request({
        url,
        method: 'GET',
      });
    },

    getLive(id: number) {
      return request({
        method: 'GET',
        url: `/live/live-sale/${id}`,
      });
    },

    trackProductView(id: string) {
      return request({
        method: 'GET',
        url: `/tracking/viewed-product/${id}`,
      });
    },

    trackLiveSaleView(id: string) {
      return request({
        method: 'GET',
        url: `/tracking/viewed-live/${id}`,
      });
    },

    async getShopInfo() {
      return await request({
        method: 'GET',
        url: `/api/shop-info`,
      });
    },

    async getFilterOptions({
      slug,
      query,
      inStockOnly,
      sizes,
      excludeWaitlist,
    }: FilterOptionsParams) {
      return await request({
        method: 'GET',
        url: `/api/filter-options`,
        params: {
          collection_slug: slug,
          query,
          in_stock_only: inStockOnly,
          sizes: sizes,
          exclude_waitlist: excludeWaitlist,
        },
      });
    },
  };
};

export default createRestClient;
